import { Trans, useTranslation } from "i18n";
import { SubscriptionTypes } from "component-library";

interface Props {
  fromPlan: SubscriptionTypes;
  priceWithTax: string;
  priceWithoutTax: string;
  subscriptionTimePeriod: string;
}

const ReinstateOriginalPlanModalSubscriptionBatch = ({
  fromPlan,
  priceWithTax,
  priceWithoutTax,
  subscriptionTimePeriod,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between rounded-[5px] bg-color-brand-two p-4 text-white">
      <div>
        <p className="text-[22px] uppercase leading-[30px]">{fromPlan}</p>
      </div>
      <div className="flex min-w-[200px] flex-col items-center justify-center">
        <p className="text-[26px]">
          <Trans
            i18nKey="performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.priceWithTax"
            values={{
              priceWithTax,
              subscriptionTimePeriod,
            }}
            components={{
              span: <span className="text-[16px]" />,
            }}
          />
        </p>
        <p className="text-[16px] font-normal">
          {t(
            "performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.priceWithoutTax",
            {
              priceWithoutTax,
            }
          )}
        </p>
      </div>
    </div>
  );
};

export default ReinstateOriginalPlanModalSubscriptionBatch;
